"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const approachesData = [{
  id: "koerper",
  title: "Körper",
  description: "Wir beginnen bei der physischen Ebene. Durch sanfte Körperarbeit und das bewusste Wahrnehmen von Spannungen lösen wir tiefsitzende Blockaden. Dein Körper ist der Tempel deiner Seele – ihn zu ehren und zu pflegen, ist der erste Schritt zur ganzheitlichen Heilung und Traumaheilung. Diese physische Erdung ermöglicht es dir, wieder eine vertrauensvolle Verbindung zu sich selbst aufzubauen und emotionale Lasten sanft loszulassen.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_lavender_petals.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_lavender_petals.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_lavender_petals.png-wvc-sizes",
  imageAlt: "Makroaufnahme von zarten Lavendelblüten",
  reverse: false
}, {
  id: "geist",
  title: "Geist",
  description: "Emotionale Klarheit und mentale Ruhe stehen im Zentrum meiner Arbeit mit dem Geist. Mit erfolgreichen Ansätzen zur Stressreduktion und geführten Meditationen helfe ich dir, das Gedankenkarussell zu stoppen und innere Stille zu finden.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_mountain_stone_texture.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_mountain_stone_texture.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_mountain_stone_texture.png-wvc-sizes",
  imageAlt: "Detaillierte Textur eines massiven Bergsteins",
  reverse: true
}, {
  id: "seele",
  title: "Seele",
  description: "Geerdetes spirituelles Wachstum ohne esoterische Klischees. Ich begleite dich auf dem Weg zu deiner inneren Essenz. Durch Energiearbeit und tiefe Reflexion öffne ich Räume für persönliche Transformation und authentische Entwicklung.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_water_surface_ripples.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_water_surface_ripples.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581972/img/macro_water_surface_ripples.png-wvc-sizes",
  imageAlt: "Sanfte Wellen auf einer klaren Wasseroberfläche",
  reverse: false
}];
function ApproachRow({
  item,
  "data-index": dataIndex
}: {
  item: (typeof approachesData)[0];
  "data-index": number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <div id={item.id} ref={ref} data-index={dataIndex} className={cn("flex flex-col gap-12 md:gap-24 items-center transition-all duration-1000 ease-out", item.reverse ? "md:flex-row-reverse" : "md:flex-row", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
      <div className="flex-1 space-y-6 md:space-y-8 w-full">
        <h3 className="font-serif text-foreground tracking-tight text-5xl md:text-7xl lg:text-8xl">
          {item.title}
        </h3>
        {item.id === "koerper"}
        <p className="text-lg md:text-xl text-muted-foreground leading-[1.8] max-w-xl">
          {item.description}
        </p>
      </div>
      <div className="flex-1 w-full">
        <div className="relative aspect-[4/5] md:aspect-square lg:aspect-[4/5] w-full overflow-hidden rounded-sm bg-muted">
          <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.imageAlt} className="object-cover transition-transform duration-1000 !opacity-[1] !w-auto !h-auto hover:scale-105" loading="lazy" />
        </div>
      </div>
    </div>;
}
export default function HolisticApproaches() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="ganzheitliche-ansätze" className="bg-background py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={cn("max-w-3xl mb-20 md:mb-32 transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h4 className="text-sm font-medium tracking-widest text-primary uppercase mb-4">
            Wandelherz Philosophie
          </h4>
          <p className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight">
            Ein harmonisches Zusammenspiel für deine persönliche Transformation.
          </p>
        </div>

        <div className="flex flex-col gap-24 md:gap-40">
          {approachesData.map((item, i) => <ApproachRow key={item.id} item={item} data-index={i} />)}
        </div>
      </div>
    </section>;
}